import { useState, useRef } from 'react';
import { 
	SimpleInfoBoxWrapper,
	SimpleInfoBoxText,
	IconWrapper,
	SimpleInfoBoxContent,
	SimpleInfoBoxContentWrap,
	SimpleInfoBoxHeadline,
	SimpleInfoBoxContainer,
	SimpleInfoBoxContentWrapper,
	SimpleInfoBoxLink,
} from './SimpleInfoBox.styled';
import { Icon } from '../icon/Icon';
import type { IconName } from '../icon';

export const ANIMATION_DURATION_MS = 300;

interface Props {
	text: string;
	variant: 'info' | 'warning' | 'danger' | 'success' | 'neutral';
	headline: string;
	isVisible?: boolean;
	linkText?: string;
	linkUrl?: string;
	linkIcon?: IconName;
	linkTarget?: string;
}

type IconMapping = {
	success: IconName;
	info: IconName;
	warning: IconName;
	danger: IconName;
	neutral: IconName;
};

const iconMapping: IconMapping = {
	success: 'circle-check',
	info: 'info-icon-new',
	warning: 'warning-new',
	danger: 'exclamation-circle-outline',
	neutral: 'tooltip',
} as const;

export const SimpleInfoBox = ({ 
	text,
	variant,
	headline,
	linkText,
	linkUrl,
	linkIcon = 'external-link',
	linkTarget = '_blank',
}: Props) => {
	const [height] = useState<string>('auto');
	const contentRef = useRef<HTMLDivElement>(null);

	const getIcon = (): IconName => {
		return iconMapping[variant];
	};

	return (
		<SimpleInfoBoxWrapper 
			$variant={variant} 
			$isExiting={false}
			$height={height}
			ref={contentRef}
			style={{
				height: height,
			}}
		>
			<SimpleInfoBoxContainer>
				<SimpleInfoBoxContent>
					<SimpleInfoBoxContentWrap>
						<IconWrapper $variant={variant}>
							<Icon icon={getIcon()} />
						</IconWrapper>
						<SimpleInfoBoxContentWrapper>
							<SimpleInfoBoxHeadline $variant={variant}>{headline}</SimpleInfoBoxHeadline>
							<SimpleInfoBoxText $variant={variant}>
								{text}
								{linkText && linkUrl && (
									<>
										{' '}
										<SimpleInfoBoxLink href={linkUrl} target={linkTarget} rel="noopener noreferrer">
											{linkText}
											{linkIcon && <Icon icon={linkIcon} />}
										</SimpleInfoBoxLink>
									</>
								)}
							</SimpleInfoBoxText>
						</SimpleInfoBoxContentWrapper>
					</SimpleInfoBoxContentWrap>
				</SimpleInfoBoxContent>
			</SimpleInfoBoxContainer>
		</SimpleInfoBoxWrapper>
	);
};
